import { render, staticRenderFns } from "./RegistrationSuccessModel.vue?vue&type=template&id=12a2627a&scoped=true"
import script from "./RegistrationSuccessModel.vue?vue&type=script&lang=js"
export * from "./RegistrationSuccessModel.vue?vue&type=script&lang=js"
import style0 from "./RegistrationSuccessModel.vue?vue&type=style&index=0&id=12a2627a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a2627a",
  null
  
)

export default component.exports